
import { AudioManager, Track } from "../../AudioManager";
import { ISystemContext } from "../../Context/SystemContext";
import { Timeout } from "../../Context/Timeout";
import { MoneyFormatter } from "../../MoneyFormatter";
import { FontResource } from "../../ResourceManager/FontResource";
import { ImageResource } from "../../ResourceManager/ImageResource";
import { Resourceful, Resourceful2 } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { Translator, TranslatedLocation } from "../../Translator";
import { Size, SetStyles, Log, Rect } from "../.././MyHelpers";
import { BonuRecoverStatus } from "../Bonus/SlotBonus";
import { SlotBonus2 } from "../Bonus/SlotBonus2";
import { SlotBonusParams } from "../Bonus/SlotBonusParams";
import { IBonusStartConfig, BonusFinish } from "../SlotGame";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { IPickBonusStartConfig } from "./PickBonus";
import { IPickBonusConfiguration, PickBonusParams, PickBonusReward, PickBonusCashReward, PickBonusJackpotReward } from "./PickBonusParams";
import { PickBonusSession } from "./PickBonusSession";
import { PickJackpot } from "./PickJackpot";
import { PickBonusMessages } from "./PickMessage";
import { Settings } from "../../Settings";
import { ZIndex } from "../../ZIndex";
import { Money } from "../../Money";import { ISimpleBonusAction } from "../../api";
;

export interface PickBonus2Params extends SlotBonusParams {
	readonly gameName: string;
	readonly gameBonusResourcesBasePath: string;
	readonly commonBonusResourcesBasePath: string
    readonly viewSize: Size;
	readonly bonusConfiguration: IPickBonusConfiguration ;
	readonly moneyFormatter: MoneyFormatter;
	readonly translator:Translator;
	readonly audio:AudioManager;
}

export interface IPickBonusAction  extends ISimpleBonusAction{
	ReelsBeforeFeatures: string[][];
	PickedIndex: number;
	AwardType: string;
	WinAmount: Money;
	InCents: number;
	JackpotName: string;
	Action: string;
	CurrentPage: number;
	JackpotCount: number;
	WinUpToNow: Money;
	NextPage: boolean;

}

export class PickBonus2 extends SlotBonus2 implements Resourceful2
{

	//public static readonly BonusName: string = "PickBonus";

	protected view: HTMLElement = null;
	protected override resid: ResourceIdentifier;
	protected override gameresid: ResourceIdentifier = null;

	//protected transition: SceneTransition = null;

	//protected gameTitle: HTMLElement = null;

	protected params: PickBonus2Params = null;
	protected paramsscren : PickBonusParams;
	protected gameResourcesBasePath: string;
	protected commonResourcesBasePath: string;
	protected viewSize: Size;

	protected session: PickBonusSession = new PickBonusSession();

    protected pickLeft:HTMLElement = null;
	protected level:HTMLElement = null;
	
	protected winCount:HTMLElement= null;

	//CREATE A CANVAS FOR WINCOUNT
	public winCountcanvas: HTMLCanvasElement = null;
	protected ctx:CanvasRenderingContext2D = null;
	protected fontHeight:number=135;

	//CHANGE FRAME TO SPRITE
	protected FrameSprite: CanvasSprite = null;
	protected FrameSpriteDelayTimer: Timeout = null;


	//protected win: HTMLElement= null;
	//protected winCreditAnimation: TweenMax = null;
	//protected winValues: any = {win:0};
	protected basepath: string = null;

	protected titleSprite: CanvasSprite = null;
	protected titleSpriteDelayTimer: Timeout = null;
	//protected bigWinCountAnimation: BigWinCountAnimation = null;
    protected jackpotContainer: HTMLElement = null;

    protected pickJackpots:Map<string,PickJackpot> = new Map<string,PickJackpot>();

    /* protected jp1Logo:HTMLElement = null;
	protected jp2Logo:HTMLElement = null;
	protected jp3Logo:HTMLElement = null;
	protected jp4Logo:HTMLElement = null; */
	
	//Background WinContainer
	protected winBackDark:HTMLElement = null;
	protected winContainer:HTMLElement = null;
	protected totalWinText: HTMLElement = null;
	//Background 2
	protected potImage2:ImageResource = null;

	protected jp1Image:ImageResource = null;
	protected jp2Image:ImageResource = null;
	protected jp3Image:ImageResource = null;
	protected jp4Image:ImageResource = null;

	protected infoContainer:HTMLElement = null;
	protected moneyFormatter: MoneyFormatter = null;
	protected translator:Translator;
	protected audio:AudioManager ;

	protected BonusName(): string
	{
		return "PickBonus";
	}

	public constructor(gameResid: ResourceIdentifier, params: PickBonus2Params) {
		super(params.gameName, params);
		
        this.translator=params.translator;
		this.gameresid = gameResid;
		this.resid = gameResid.Add("PickBonus2");
		this.audio=params.audio;
		this.params = params;
		this.gameResourcesBasePath = params.gameBonusResourcesBasePath;
		this.commonResourcesBasePath = params.commonBonusResourcesBasePath;
		this.viewSize = params.viewSize;

		this.basepath = Settings.ResourcesFolder + "multigame/slot/" + params.gameName + "/";

		this.view = document.createElement("div");
		this.view.classList.add(this.resid.Scope());
		this.view.style.position = "absolute";
		this.view.style.top = "0px";
		this.view.style.left = "0px";
		this.view.style.width = this.viewSize.Width + "px";
		this.view.style.height = this.viewSize.Height + "px";

		//this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.PrepareMessage.msgname, (m) => this.Prepare((<PickBonusMessages.PrepareMessage>m)), this.screenProtocolScope);

		this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.PickMessage.msgname, (m) => {
			let pm: PickBonusMessages.PickMessage = m as PickBonusMessages.PickMessage;
			this.OnPick(pm.session);
		}, this.screenProtocolScope);

		this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.AwardMessage.msgname, (m) => this.Win((<PickBonusMessages.AwardMessage>m)), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.CommetPickComplete.msgname, (m) => this.OnCometePickComplete((<PickBonusMessages.CommetPickComplete>m)), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.CommetJPComplete.msgname, (m) => this.OnCometeJPComplete((<PickBonusMessages.CommetJPComplete>m)), this.screenProtocolScope);
		this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.JpShowFinish.msgname, (m) => this.JpOnShowFinished((<PickBonusMessages.JpShowFinish>m)), this.screenProtocolScope);
		

		this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.IntroMessage.msgname, (m) => this.Intro((<PickBonusMessages.IntroMessage>m)), this.screenProtocolScope);

		this.moneyFormatter = params.moneyFormatter;
	}

	public async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
        
		for(let i = 0 ; i < this.params.bonusConfiguration.RequiredJpToWin.length; i++)
		{
			let pickJackpot:PickJackpot = new PickJackpot(this.params.bonusConfiguration.RequiredJpToWin[i].Name,this.resid,this.params,this.params.bonusConfiguration.RequiredJpToWin[i].RequiredToHit,i);
			this.pickJackpots.set(this.params.bonusConfiguration.RequiredJpToWin[i].Name, pickJackpot);
		}

		
		this.pickJackpots.forEach((jackpot:PickJackpot)=>
		{
			jackpot.PrepareResources(resourceManager);
		});
			//LOAD SPRITE WIN COUNT FRAME
			this.SpriteWinFramePrepare(resourceManager);
		//LOAD AUDIO
		this.AudioPrepare(resourceManager);
	
		this.BasePrepare(resourceManager);
		//LOAD FONT
		this.PrepareFont(resourceManager);
		//this.TitlePrepare(resourceManager);	
		
		this.PrepareinfoContainer(resourceManager);
	}
	public AudioPrepare(resourceManager: IWriteOnlyResourceManager):void
	{
		//LOAD LIGHTING
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "WinCount" + Settings.audioFormat, this.resid.ScopedResourceName("WinCount")));
		console.log("load audio");
	}
    
    protected BasePrepare(resourceManager: IWriteOnlyResourceManager):void
    {
        resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "sapphire.png", this.resid.ScopedResourceName(["jp1", "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "emerald.png", this.resid.ScopedResourceName(["jp2", "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "ruby.png", this.resid.ScopedResourceName(["jp3", "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "diamond.png", this.resid.ScopedResourceName(["jp4", "image"])));

		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "bonusWin.png", this.resid.ScopedResourceName(["bonusWin", "image"])));

		//resourceManager.Add(new ImageResource(this.params.gameResourcesBasePath + "frame.png", this.resid.ScopedResourceName(["frame", "image"])));
		resourceManager.Add(new ImageResource(this.params.commonBonusResourcesBasePath + "frame.png", this.resid.ScopedResourceName(["frame", "image"])));
		//Chili Second Screen
		resourceManager.Add(new ImageResource(this.params.gameBonusResourcesBasePath + "background.2.jpg", this.resid.ScopedResourceName(["background2", "image"])));
		//LOAD LIGHTING
		this.audio.AddTrack(new Track(this.params.commonBonusResourcesBasePath + "tracks/WinCount" + Settings.audioFormat, this.resid.ScopedResourceName("WinCount")));
		console.log("load audio");
	}

	protected PrepareFont(resourceManager: IWriteOnlyResourceManager):void
	{
		resourceManager.Add(new FontResource(this.params.commonBonusResourcesBasePath + "newzone.ttf", this.resid.ScopedResourceName("BonusWinFont")));
	}

	//ADD SPRITE WIN COUNT CANVAS
	public SpriteWinFramePrepare(resourceManager: IWriteOnlyResourceManager)
	{
		resourceManager.Add(new SpriteResource(this.params.commonBonusResourcesBasePath + "frameSprite", this.resid.Add("frameSprite"), true, this.logGroup.Add("frameSprite"), true));
	}
	
	/* public TitlePrepare(resourceManager: IWriteOnlyResourceManager)
	{
		resourceManager.Add(new SpriteResource(this.params.commonBonusResourcesBasePath + "title", this.resid.Add("title"), true, this.logGroup.Add("title"), true));
	} */

	public SpriteWinFrameLoaded(resourceManager: IReadOnlyResourceManager)
	{
		
		//CHANGE TO SPRITE 
		let sprite = resourceManager.Get<SpriteResource>(this.resid.Add("frameSprite")).sprite;
		this.FrameSprite = new CanvasSprite({sprite: sprite, canvasSize: new Size(1100,500)});
		//this.FrameSprite.View().style.zIndex="4";
		this.FrameSprite.View().style.position="absolute";
		this.FrameSprite.View().style.top= "-28px";
		this.FrameSprite.AddOnStartCallback(() => this.audio.Play(this.resid.ScopedResourceName("WinCount")));
		
	
			//ADD NEW FRAME SPRITE IN CONTAINER
			this.winContainer.appendChild(this.FrameSprite.View());
	}

/* 	public TitleLoaded(resourceManager: IReadOnlyResourceManager)
	{
		let sprite = resourceManager.Get<SpriteResource>(this.resid.Add("title")).sprite;
		this.titleSprite = new CanvasSprite(sprite, new Size(1920,400));
		this.titleSprite.View().style.zIndex="4";
		this.titleSprite.View().style.position="absolute";

		//this.view.appendChild(this.titleSprite.View());

		this.titleSpriteDelayTimer = new Timeout(() => {

				this.titleSprite.Restart();
				this.titleSpriteDelayTimer.Timeout = Math.floor(Math.random() * 3000) + 5000;
				this.titleSpriteDelayTimer.Restart();
			},
			Math.floor(Math.random() * 3000) + 5000
		);

		//this.titleSprite.Start(false);

		 this.titleSprite.AddOnCompleteCallback(()=> setTimeout(()=>
			this.titleSprite.Start(false)
		,5000)); 
	} */




	public BaseLoaded(resourceManager: IReadOnlyResourceManager):void
	{
		
		this.jp1Image = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp1", "image"]));
		this.jp2Image = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp2", "image"]));
		this.jp3Image = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp3", "image"]));
		this.jp4Image = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["jp4", "image"]));
	}

	protected CanvaswinCount()
	{
		this.winCountcanvas=document.createElement("canvas");
		this.winCountcanvas.width = 940;
		this.winCountcanvas.height = 170;
		this.winCountcanvas.style.left = 488+ "px";
		this.winCountcanvas.style.top = 123 + "px";
		this.winCountcanvas.style.position = "absolute";
		this.winCountcanvas.style.display = "flex";
		this.winCountcanvas.style.alignItems = "center";
		this.winCountcanvas.style.justifyContent = "center";
		//this.winCountcanvas.style.zIndex="3";
		this.winCountcanvas.style.zIndex = ""+ ZIndex.BonusWin;

		//add gradient
		this.ctx = this.winCountcanvas.getContext("2d");
		
       // this.ctx.font = "120px Verdana" /*+ this.font*/;
		this.ctx.font = "bold " + this.fontHeight + "px " + this.resid.ScopedResourceName("BonusWinFont");

		let color:string="orangered";
		let color2:string="yellow";

		let gradient = this.ctx.createLinearGradient( this.winCountcanvas.width /2, 
			this.winCountcanvas.height /2 - this.fontHeight/2, 
			this.winCountcanvas.width /2, 
			this.winCountcanvas.height /2 + this.fontHeight/2
		);
		
		gradient.addColorStop(0,color);
			
		gradient.addColorStop(0.10,color);
		
		
		gradient.addColorStop(0.70,color2);
		
		gradient.addColorStop(1,color2);
		
		this.ctx.fillStyle = gradient;
		this.ctx.shadowColor="black";
		this.ctx.shadowOffsetX = 1;
		this.ctx.shadowOffsetY = 1;
		this.ctx.shadowBlur = 2;
		
		
		//this.ctx.textBaseline = "hanging";
		this.ctx.textBaseline = "top";
		this.ctx.textAlign="center";

		
			

	}

	protected fillTextCanvas(CurrentWin:string)
	{
		//CHANGE SIMPLE TEXT TO CANVAS 
		this.ctx.clearRect(0,0,this.winCountcanvas.width,this.winCountcanvas.height);
		
		/* this.ctx.strokeStyle = "black";
		this.ctx.lineWidth = 10 ;  
		this.ctx.strokeText(CurrentWin,(this.winCountcanvas.width/2)+5,this.winCountcanvas.height/4);
		 */
		this.ctx.strokeStyle = "white";
		this.ctx.lineWidth = 5 ;  
		this.ctx.strokeText(CurrentWin,(this.winCountcanvas.width/2)+5,(this.winCountcanvas.height/4)-15);
		
		this.ctx.fillText(CurrentWin,(this.winCountcanvas.width/2)+5,(this.winCountcanvas.height/4)-15);
		

	}

	protected WinContainerLoaded(resourceManager: IReadOnlyResourceManager):void
	{

		
		this.winContainer = document.createElement("div");
		this.winContainer.classList.add(this.resid.Scope());
		this.winContainer.classList.add("WinContainer");
		SetStyles(this.winContainer,
		{
			position : "absolute",
			top: "130px",
			left: "0px",
			width: "100%",
			height: "350px",
			display:"flex",
			flexDirection:"column",
			justifyContent:"center",
			alignItems:"center",
			zIndex:"3",
		});
		//Dark Bacground to Win Count
		this.winBackDark = document.createElement("div");
		this.winBackDark.classList.add("DarkBckWin");
		SetStyles(this.winBackDark,
		{
			height:"203px",
			width:"1016px",
			background:"RGBA(0,0,0,0.7)",
			zIndex:"0",
			top:"123px",
			position:"absolute",
			left:"448px"
		});

		this.winCount = document.createElement("div");
		this.winCount.classList.add(this.resid.Scope());
		this.winCount.classList.add("WinCount");
		SetStyles(this.winCount,
		{
			height:"60%",
			width:"50%",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			fontSize: "120px",
			fontFamily: "NotoSansDisplay-Bold",
			color: "white",
			textShadow: "black 0px 0px 5px, black 0px 0px 15px, black 0px 0px 30px",
			border: "40px solid transparent",
			backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["frame","image"])).CssBackground(),
			backgroundRepeat: "no-repeat",
			backgroundSize: "cover",
			backgroundPosition:"center",
			zIndex:"3",
			position:"absolute",
			top:"74px",
		});




		//


		this.totalWinText = document.createElement("div");
		this.totalWinText.classList.add(this.resid.Scope());
		this.totalWinText.classList.add("WinText");

		SetStyles(this.totalWinText,
		{
			height: "184%",
			width: "70%",
			fontSize: "80px",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",

			backgroundImage:resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["bonusWin", "image"])).CssBackground(),
			backgroundRepeat: "no-repeat",
			backgroundSize: "contain",
			backgroundPosition:"center",
			zIndex:"3",
			position:"absolute",
			top:"-325px",
		});
		//CHANGE WINCOUNT TO CANVAS
		this.CanvaswinCount();

		this.winContainer.appendChild(this.winBackDark);
		this.winContainer.appendChild(this.totalWinText);
		//this.winContainer.appendChild(this.winCount);
		
		this.winContainer.appendChild(this.winCountcanvas);
		
	}

	protected PrepareinfoContainer(resourceManager: IWriteOnlyResourceManager)
	{
		this.infoContainer = document.createElement("div");
		this.infoContainer.classList.add(this.resid.Scope());
		this.infoContainer.classList.add("DiamondPotInfo");
		SetStyles(this.infoContainer,
		{
			position:"absolute",
			top:"518px",
			left:"0px",
			width:"100%",
			height:"135",
			display:"flex",
			flexDirection: "row",
			justifyContent: "space-evenly",
			zIndex:"2",
			textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)"
            
		});

		this.level = document.createElement("div");
		this.level.classList.add(this.resid.Scope());
		this.level.classList.add("PickLevel");
		SetStyles(this.level,
		{
			height:"100%",
			width:"70%",
			fontSize: "30px",
			fontFamily: "NotoSansDisplay-BoldItalic",
			color: "white",
			display:"flex",
			justifyContent:"center",
			alignItems:"center",
			textAlign:"center",
			zIndex:"2",
			textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)"
            

		});

		this.pickLeft = document.createElement("div");
		this.pickLeft.classList.add(this.resid.Scope());
		this.pickLeft.classList.add("PickLeft");
		SetStyles(this.pickLeft,
		{
			height:"100%",
			width:"50%",
			fontSize: "45px",
			fontFamily: "NotoSansDisplay-BoldItalic",
			color: "white",
			display:"flex",
			justifyContent:"center",
			alignItems:"center",
			zIndex:"2",
			textShadow: " 0 -1px 0 #fff,0 1px 0 #2e2e2e,0 2px 0 #2c2c2c,0 3px 0 #2a2a2a,0 4px 0 #282828,0 5px 0 #262626,0 6px 0 #242424,0 7px 0 #222,0 8px 0 #202020,0 15px 10px rgba(0, 0, 0, 0.9)",
            

		});

		this.infoContainer.appendChild(this.level);
		this.infoContainer.appendChild(this.pickLeft);
	}
	
	protected levelMessage: TranslatedLocation;
	protected picksLeftMessage: TranslatedLocation;

    public async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> 
    {
    	//Chili background 2
    	this.view.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background2", "image"])).CssBackground();
		this.BaseLoaded(resourceManager);
		//this.TitleLoaded(resourceManager);
		this.SpriteWinFrameLoaded(resourceManager);

        this.jackpotContainer = document.createElement("div");
		this.jackpotContainer.classList.add(this.resid.Scope());
		this.jackpotContainer.classList.add("JackpotContainer");
		SetStyles(this.jackpotContainer, 
		{
			position: "absolute",
			bottom: "0px",
			left : "0%",
			width : "100%",
			height : "40%",
			display : "flex",
			flexWrap : "wrap",
			justifyContent: "space-evenly",
			zIndex:"3",

		});

		this.pickJackpots.forEach((jackpot:PickJackpot)=>
		{
			jackpot.ResourcesLoaded(resourceManager);
			this.jackpotContainer.appendChild(jackpot.View());
		});

		this.view.appendChild(this.jackpotContainer);
		this.view.appendChild(this.winContainer);
		this.view.appendChild(this.infoContainer);

		this.levelMessage = this.translator.Translate(() => {
			switch(this.session.currentPage + 1)
			{
				case 1:
					return this.translator.t.levebonus1;
					break;
				case 2:
					return this.translator.t.levebonus2;
					break;
				case 3:
					return this.translator.t.levebonus3;
					break;
				case 4:
					return this.translator.t.levebonus4;
					break;

				default:
					return "";
					break;
			}
		});

		this.View().querySelector(".PickLevel").appendChild(this.levelMessage.location);



		this.picksLeftMessage = this.translator.Translate(() => this.translator.t.pickleft(this.session.left));
		this.View().querySelector(".PickLeft").appendChild(this.picksLeftMessage.location);

		this.WinContainerLoaded(resourceManager);
	}

	/******
		
	******/


	protected bonusStartConfig: IPickBonusStartConfig;
	public Prepare(bonusStartConfig: IBonusStartConfig): void
	{
		this.bonusStartConfig = bonusStartConfig as IPickBonusStartConfig;
	}

	protected award:PickBonusReward = null;
	protected Win(message:PickBonusMessages.AwardMessage):void
	{
		this.award = message.award;
		let pickRect: Rect = message.pick;
		let awardRect: Rect = null;

		if(this.award.PickType == 1)
		{
			let money:number = (this.award as PickBonusCashReward).Reward.InCents;
			this.session.totalWin += money;
			//this.winContainer.innerHTML = ""+this.session.totalWin;

			//CHANGE POSTION IT MOVE BONUS WIN
			awardRect = new Rect(480,260,850,200);

			//this.NextPick();
		}
		else if (this.award.PickType == 2)
		{
			let currentJackpot:PickJackpot = this.pickJackpots.get((this.award as PickBonusJackpotReward).JackpotName);
			//let freeSpotForJackpot:number = award.JackpotCount-1;
			this.session.totalWin += (this.award as PickBonusJackpotReward).WinAmount.InCents;

			awardRect = currentJackpot.CenterOfFreeSpaceForDiamond(this.award);
		}

		this.screenProtocol.Send(new PickBonusMessages.CommetDestination(awardRect),this.screenProtocolScope);
	}

	protected OnCometePickComplete(message:PickBonusMessages.CommetPickComplete):void
	{
		if(this.award.PickType ==1)
		{
			//this.winCount.innerHTML = this.moneyFormatter.FormatCurrency(this.session.totalWin);
			//CHANGE SIMPLE TEXT TO CANVAS 
			this.fillTextCanvas(this.moneyFormatter.FormatCurrency(this.session.totalWin));
			//PLAY SPRITE ONLY ONE TIME
			this.FrameSprite.Start(false);
			
		}

		else if(this.award.PickType ==2)
		{
			let jackpotReward = (this.award as PickBonusJackpotReward)
			let currentJackpot:PickJackpot = this.pickJackpots.get(jackpotReward.JackpotName);
			//let destRect = currentJackpot.CenterOfFreeSpaceForDiamond(this.award);
			let freeSpotForJackpot = currentJackpot.JpFreeSpot(jackpotReward.JackpotCount);
		
			this.AddJp(jackpotReward.JackpotName, jackpotReward.JackpotCount);
			if(freeSpotForJackpot < currentJackpot.WinContainer().length)
			{
				
				if(jackpotReward.JackpotName == "jp1")
				{
					if(jackpotReward.JackpotCount == 4)
					{
						//TweenLite.to(this.jp1Logo, 0.5, {scale:1.5, ease: Elastic.easeOut.config(1, 0.5)});
						this.screenProtocol.Send(new PickBonusMessages.CommetJp(new Rect(1044,666,601,114),new Rect(480,260,850,200)),this.screenProtocolScope);
					}
				}
				else if(jackpotReward.JackpotName == "jp2")
				{
					if(jackpotReward.JackpotCount == 4)
					{
						//TweenLite.to(this.jp2Logo, 0.5, {scale:1.5, ease: Elastic.easeOut.config(1, 0.5)});
						this.screenProtocol.Send(new PickBonusMessages.CommetJp(new Rect(245,662,601,114),new Rect(480,260,850,200)),this.screenProtocolScope);
					}

				}
				else if(jackpotReward.JackpotName == "jp3")
				{
					if(jackpotReward.JackpotCount == 4)
					{
						//TweenLite.to(this.jp3Logo, 0.5, {scale:1.5, ease: Elastic.easeOut.config(1, 0.5)});
						this.screenProtocol.Send(new PickBonusMessages.CommetJp(new Rect(328,381,1270,181),new Rect(480,260,850,200)),this.screenProtocolScope);
					}
				}
				else if(jackpotReward.JackpotName == "jp4")
				{
					if(jackpotReward.JackpotCount == 4)
					{
						//TweenLite.to(this.jp4Logo, 0.5, {scale:1.5, ease: Elastic.easeOut.config(1, 0.5)});
						this.screenProtocol.Send(new PickBonusMessages.CommetJp(new Rect(301,79,1326,197),new Rect(480,260,850,200)),this.screenProtocolScope);
					}
				}
				else
				{
					throw new Error("Unknown jackpot "+ jackpotReward.JackpotName);
				}	
			} 
		}

		//this.titleSprite.Start(false);
		
	}
	
	protected AddJp(jpName:string, count:number)
	{
		let currentJackpot:PickJackpot = this.pickJackpots.get(jpName);
			//let destRect = currentJackpot.CenterOfFreeSpaceForDiamond(this.award);
			let freeSpotForJackpot = currentJackpot.JpFreeSpot(count);
		
			if(freeSpotForJackpot < currentJackpot.WinContainer().length)
			{
				
				if(jpName == "jp1")
				{
					currentJackpot.WinContainer()[freeSpotForJackpot].style.backgroundImage = this.jp1Image.CssBackground();
					
				}
				else if(jpName == "jp2")
				{
					currentJackpot.WinContainer()[freeSpotForJackpot].style.backgroundImage = this.jp2Image.CssBackground();
				}
				else if(jpName == "jp3")
				{
					currentJackpot.WinContainer()[freeSpotForJackpot].style.backgroundImage = this.jp3Image.CssBackground();
				}
				else if(jpName == "jp4")
				{
					currentJackpot.WinContainer()[freeSpotForJackpot].style.backgroundImage = this.jp4Image.CssBackground();
				}
				else
				{
					throw new Error("Unknown jackpot "+ jpName);
				}	
			} 
	}

	protected OnCometeJPComplete(message:PickBonusMessages.CommetJPComplete)
	{	
		//this.winCount.innerHTML = this.moneyFormatter.FormatCurrency(this.session.totalWin);
		//this.titleSprite.Start(false);
		//CHANGE SIMPLE TEXT TO CANVAS 
		this.fillTextCanvas(this.moneyFormatter.FormatCurrency(this.session.totalWin));
		//PLAY SPRITE ONLY ONE TIME
		this.FrameSprite.Start(false);
	}

	protected JpOnShowFinished(message:PickBonusMessages.JpShowFinish)
	{
		//reset only hite JP
		let JP = (this.award as PickBonusJackpotReward);
		let hittedJP = this.pickJackpots.get(JP.JackpotName);

		for(let i = 0; i < hittedJP.WinContainer().length; i++)
		{
			hittedJP.WinContainer()[i].style.backgroundImage = "none";
		}
			
	}

	public OnBonusFinish(bonusFinish: BonusFinish): void {
		// Log.Debug(this.logGroup, "OnBonusFinish(bonusFinish: " + JSON.stringify(bonusFinish) + ")");

		this.audio.Stop(this.resid.ScopedResourceName("background"));
	}
	public Hide(): void {
		this.view.style.visibility = "hidden";
		console.log("Hide Pick bonus 2");
		/* this.titleSprite.Stop();
		this.titleSpriteDelayTimer.Stop();
 */
	}
	public Show(): void {
		this.view.style.visibility = "visible";
		// this.titleSpriteDelayTimer.Restart();
		console.log("Show pick bonus 2");
	}

	public Start(): void {
		if(this.session == null)
		{
			throw new Error("Session must not be null");
		}

		this.session.Reset();
		this.Reset();
	}

	public Intro(message:PickBonusMessages.IntroMessage)
	{
		//this.winCount.innerHTML = this.moneyFormatter.FormatCurrency(message.session.totalWin);
		//CHANGE SIMPLE TEXT TO CANVAS 
		this.fillTextCanvas(this.moneyFormatter.FormatCurrency(this.session.totalWin));
			

	}

	public Reset()
	{
		this.pickJackpots.forEach((jackpot:PickJackpot)=>
		{
			for(let i = 0; i < jackpot.WinContainer().length; i++)
			{
				jackpot.WinContainer()[i].style.backgroundImage = "none";
			}
		});

		//this.bonusStartConfig = null;
		
		

	}



	public Update(): void {
		//this.transition.Update();
		//this.titleSprite.Update();
		//this.titleSprite.Update();
		this.FrameSprite.Update();

	}

	public View(): HTMLElement {
		return this.view;
	}

	/*********
		SCREEN PROTOCOL EVENTS
	**********/

	protected OnPick(session: PickBonusSession): void {
		if(session == null)
		{
			throw new Error("Session must not be null");
		}

		//this.transition.Start();
		this.session.Update(session);
		this.ApplySession();
	}



	protected ApplySession() {
        /*
        this.elemWon.innerHTML = "" + this.session.awarded;
		this.elemPlayed.innerHTML = "" + this.session.played;
		this.elemLeft.innerHTML = "" + this.session.left;
		//this.win.innerHTML = ""+this.session.totalWin;
		this.bigWinCountAnimation.Display(this.session.totalWin);*/

		this.levelMessage.Update();
		this.picksLeftMessage.Update();
	}

	public Stop()
	{
		//this.bigWinCountAnimation.View().style.visibility = "hidden";
	}
}



export interface IPickBonusFactory2
{
	CreatePickBonus2(gameName: ResourceIdentifier, params: PickBonus2Params): PickBonus2;
}

export class PickBonusFactory2 implements IPickBonusFactory2
{
	
	public CreatePickBonus2(gameName: ResourceIdentifier, params: PickBonus2Params): PickBonus2 
	{
		return new PickBonus2(gameName, params);
	}
}




